<template lang="pug">
  el-button(
    :type="tipo",
    :disabled="disabled",
    :class="tipo",
    @click="goTo",
    :size="size"
    :loading="loading"
  )
    span.center
      i(
        v-if="icone && !loading",
        :class="icone",
      )
      b &nbsp {{ titulo }}
</template>

<script>
export default {

  props: {
    titulo: {
      type: String,
      required: true
    },
    tipo: {
      type: String,
      required: true
    },
    scale: {
      type: String,
      default: '1'
    },
    size: {
      type: String,
      default: 'medium'
    },
    scope: {
      type: String
    },
    modulo: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    icone: String,
    color: String,
    link: String,
    disabled: Boolean,
    method: String
  },

  methods: {
    goTo () {
      if (this.link) {
        if (this.scope) {
          this.$router.push({
            name: this.link,
            params: {
              scope: this.scope
            }
          })
        } else {
          this.$router.push({ name: this.link })
        }
      } else
      if (this.method) {
        this.$emit(this.method)
      }
    }
  }

}
</script>

<style scoped lang="scss">

  .component {

    .text-btn {
      color: #575757;
      padding: 0;
    }

    .center {
      display: flex;
      align-items: center;
    }

    .text {
      color: #575757;
      padding: 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AppButton.vue